import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, of, take } from 'rxjs';
import { DocksModel } from 'src/app/models/DocksModel';
import { ReceivingService } from 'src/app/services/receiving/receiving.service';

@Component({
  selector: 'app-lcb-recebimento',
  templateUrl: './lcb-recebimento.component.html',
  styleUrls: ['./lcb-recebimento.component.css'],
})
export class LCBRecebimentoComponent {

  dateInterval: any
  updateInterval: any
  Date = Date.now();

  private readonly DEFAULT_COLOR = '#FFF'
  private readonly ACTIVE_COLOR = '#3CB371'
  private readonly INACTIVE_COLOR = '#FF2340'

  recDocks: DocksModel[] = []
  
  selectedDockId: number | null = null;

  constructor(
    private recService: ReceivingService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.dateInterval = setInterval(() => {
      this.Date = Date.now();
      this.updateData()
      this.route.params.subscribe(params => {
        if (params['id']) {
          this.selectedDockId = +params['id'];
        }
      })
    }, 5000);
  }


  updateData(): void {
    this.recService.getRecDocksData().pipe
      (take(1),
        catchError(() => {
          return of({ recDocks: [] })
        })
      ).subscribe(
        (response) => {
          this.recDocks = response.recDocks.map(d => ({
            ...d,
            status: new Date(d.status + 'Z')
          }));
        }
      )
  }

  ngOnDestroy() {
    clearInterval(this.dateInterval);
    clearInterval(this.updateInterval);
  }

  //* ---------------------- BOTÕES DOCAS ---------------------- *//

  public statusDocks(docks: number): string {
    const dock = this.recDocks.find((t) => t.id == docks);
    if (this.isDockValidAndActive(dock)) {
      switch (dock?.truck) {
        case 0:
          return this.DEFAULT_COLOR
        case 1:
          return this.ACTIVE_COLOR
        default:
          return "Valor no campo 'Truck' inválido"
      }
    } return this.INACTIVE_COLOR
  }

  private isDockValidAndActive(dock: any): boolean {
    return dock && dock.truck !== undefined && dock.status && dock.active == 1
  }

}